package org.example.site_web.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initWebsiteCreditsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("WebsiteCredits.md", FrontMatterElement.Builder { addScalar("title", "About"); }))
}

@Page("/website-credits")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun WebsiteCreditsPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("a-propos-de-ce-site") }) {
        org.jetbrains.compose.web.dom.Text("A propos de ce site")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Ce site ne collecte aucune donnée personelle.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Ce site est développé avec Kobweb - ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://kobweb.varabyte.com/") {
            org.jetbrains.compose.web.dom.Text("https://kobweb.varabyte.com/")
        }
    }
}
